<template>
  <div>this is manager</div>
</template>

<script>
  export default {
    name: 'manager'
  }
</script>

<style scoped>

</style>
